module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/inner-3-177f4d3e420d77949e8352ec4c13e325.jpg";